var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "288px",
    viewBox: "0 0 147 288",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "kyc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "**ONBOARDING**",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KYC-Failed",
    transform: "translate(-647.000000, -219.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kyc",
    transform: "translate(647.000000, 219.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.200000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.15,277.14 C0.15,283.11 31.74,287.97 70.68,287.97 C109.62,287.97 141.21,283.14 141.21,277.14 C141.21,271.17 109.62,266.31 70.68,266.31 C31.74,266.34 0.15,271.17 0.15,277.14 Z",
    id: "Path",
    fill: "#E8E8E8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.900000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 12.600000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.19,115.44 C11.88,121.05 16.44,184.5 16.44,184.5 L33.54,183.39 L41.91,143.58 C41.91,143.58 42.96,181.68 46.41,189.6 C49.86,197.52 63.15,183.78 63.15,183.78 C63.15,183.78 76.41,137.31 66.12,110.73 C59.34,110.73 27.54,112.2 23.19,115.44 Z",
    id: "Path",
    fill: "#070532",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2,259.5 C23.43,261.18 8.7,263.91 5.07,264.06 C2.82,264.15 3.78,261.54 6.57,260.67 C12.42,258.84 18.66,252.63 18.66,252.63 L24.54,252.42 C24.54,252.42 26.97,257.82 25.2,259.5 Z",
    id: "Path",
    fill: "#070307",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.46,252.66 L25.77,252.36 C25.77,252.36 35.19,202.92 35.22,195.3 C35.25,187.71 33.51,183.39 33.51,183.39 L26.97,179.19 L16.41,184.5 L17.46,252.66 Z",
    id: "Path",
    fill: "#070532",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.61,252.66 C23.61,252.66 30.24,211.05 30.69,202.41 C31.23,192.09 30.36,184.53 30.54,182.31 C30.96,177.15 37.29,146.49 37.29,146.49",
    id: "Path",
    stroke: "#05031F",
    strokeWidth: 0.68427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.82,259.53 C61.11,261.24 46.44,264.33 42.78,264.57 C40.53,264.72 41.43,262.08 44.19,261.15 C49.98,259.2 55.74,252.48 55.74,252.48 L61.41,251.579893 C61.44,251.55 64.53,257.82 62.82,259.53 Z",
    id: "Path",
    fill: "#070307",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.33,252.69 L62.55,251.37 C62.55,251.37 65.82,201.15 64.92,193.59 C64.02,186.03 63.45,182.79 63.45,182.79 L54.78,178.62 L45.42,186.21 L54.33,252.69 Z",
    id: "Path",
    fill: "#070532",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.42,251.94 C60.42,251.94 61.89,209.82 61.29,201.18 C60.57,190.86 58.74,183.48 58.68,181.26 C58.47,176.1 67.56,143.31 63.24,122.55",
    id: "Path",
    stroke: "#05031F",
    strokeWidth: 0.68427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000206",
    fillRule: "nonzero",
    points: "40.14 152.07 41.94 143.58 28.02 137.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,37.92 L18.99,14.4 C18.99,14.4 18.84,12.36 18.96,11.07 C19.05,10.17 21.21,6.45 21.51,5.37 C21.81,4.29 25.5,6.15 26.04,7.29 C26.58,8.4 25.26,13.41 24.75,14.1 C24,15.18 21.72,15.93 21.72,15.93 L9.87,41.22 L3,37.92 Z",
    id: "Path",
    fill: "#FDAB70",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.35,17.31 C22.35,17.31 15.66,36.69 11.01,42.63 C13.32,43.38 25.29,44.67 30.69,43.38 C34.41,42.48 32.61,69.36 26.16,69.4202071 C17.22,69.48 5.25,56.49 1.47,49.8 C-5.73,37.11 17.88,14.94 17.88,14.94 L22.35,17.31 Z",
    id: "Path",
    fill: "#1C65AB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.15,49.86 C23.37,53.55 18.69,58.26 15.15,64.8 C18.84,67.53 22.71,69.42 26.13,69.42 C30.66,69.39 32.88,56.25 32.55,48.66 C31.77,49.02 30.93,49.44 30.15,49.86 Z",
    id: "Path",
    fill: "#0F325F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.61,131.55 C24.39,130.65 26.85,128.01 26.85,128.01 L37.29,128.88 C37.29,128.88 43.68,135.42 47.22,135.03 C55.29,134.1 63.09,127.41 69.09,122.25 C68.46,118.17 67.53,114.3 66.15,110.76 C59.34,110.76 27.51,112.23 23.19,115.47 C20.16,116.97 18.27,122.58 17.13,130.02 C18.93,130.98 21.99,133.44 23.61,131.55 Z",
    id: "Path",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.98,5.79 C25.98,5.79 21,6.09 21.69,13.17 C21.99,16.26 26.58,25.98 26.58,25.98 L32.01,8.19 L25.98,5.79 Z",
    id: "Path",
    fill: "#020311",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.79,117.75 C66.6,123.36 18.45,128.19 15.93,122.79 C13.41,117.39 19.86,92.31 20.58,80.01 C21.24,68.91 29.28,45.63 29.28,45.63 L34.74,43.2 L44.97,42.48 C44.97,42.48 54.9,44.22 57.06,47.16 C59.22,50.1 62.13,67.41 62.79,79.08 C63.48,91.29 70.98,112.17 68.79,117.75 Z",
    id: "Path",
    fill: "#E5E5E5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.02,128.82 C19.32,129.33 14.61,126.33 14.07,125.16 C11.55,119.76 18.57,92.04 19.17,79.74 C19.98,62.97 27.12,46.47 28.56,44.58 C30,42.69 34.71,43.2 34.71,43.2 C34.71,43.2 28.68,50.37 28.02,62.25 C27.39,74.1 24.72,128.31 22.02,128.82 Z",
    id: "Path",
    fill: "#1C65AB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.79,117.75 C67.74,120.48 55.02,128.82 42.69,128.850011 C36.63,128.88 38.04,66.75 38.25,60.27 C38.46,53.76 44.22,43.05 44.94,42.45 C45.63,41.85 52.05,44.19 55.71,43.17 C59.22,42.18 62.07,67.38 62.76,79.05 C63.48,91.29 70.98,112.17 68.79,117.75 Z",
    id: "Path",
    fill: "#1C65AB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.27,28.56 C24.9,32.07 28.02,37.35 29.67,38.64 C31.32,39.93 34.65,39.06 34.65,39.06 L34.74,43.17 C34.74,43.17 30.39,48.39 35.73,48.93 C41.07,49.47 44.97,42.45 44.97,42.45 L44.34,35.34 C44.34,35.34 44.07,30.63 45.9,26.07 C47.76,21.33 49.2,20.73 48.78,15.18 C48.27,8.19 40.35,3.15 40.35,3.15 L27.12,7.71 C27.12,7.71 26.22,7.8 25.35,9.39 C24.06,11.73 23.82,14.88 23.82,16.71 C23.79,20.31 23.67,25.05 24.27,28.56 Z",
    id: "Path",
    fill: "#FDAB70",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.65,39.03 L34.74,41.85 C34.74,41.85 36.96,41.07 39,39.54 C41.37,37.74 42.63,33.06 42.63,33.06 C42.63,33.06 39.63,36.42 38.67,37.05 C37.74,37.74 34.65,39.03 34.65,39.03 Z",
    id: "Path",
    fill: "#F58E57",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.36,6.87 C50.64,7.68 51.78,9.54 52.05,12.9 C52.26,15.72 48.78,23.55 48.18,25.29 C47.58,27.03 43.35,25.02 43.35,25.02 L42.27,24.3 C42.27,24.3 43.65,16.35 42.6,15.18 C37.92,9.99 33.45,18.6 25.68,10.8 C24.6,9.72 22.83,2.28 27.45,0.69 C32.07,-0.9 46.44,0.72 48.36,6.87 Z",
    id: "Path",
    fill: "#020311",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.35,24.99 C41.31,25.29 43.98,26.88 45.51,26.91 C47.01,26.94 48.33,25.98 48.33,23.91 C48.33,22.44 47.37,21.51 45.87,21.45 C44.37,21.39 44.1,24.36 43.35,24.99 Z",
    id: "Path",
    fill: "#FDAB70",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.14,23.55 L47.64,11.01 C47.64,11.01 46.77,9.18 46.02,8.1 C45.51,7.38 41.79,5.19 40.98,4.41 C40.2,3.63 37.92,7.05 37.98,8.31 C38.07,9.54 41.67,13.23 42.45,13.62 C43.62,14.19 45.99,13.71 45.99,13.71 L68.76,29.85 L73.14,23.55 Z",
    id: "Path",
    fill: "#FDAB70",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.11,15.18 C46.11,15.18 61.5,28.74 68.49,31.59 C66.87,33.39 60.66,40.56 55.74,43.17 C52.35,44.97 54.93,76.74 61.05,74.73 C71.58,71.28 80.31,40.8 80.31,33.09 C80.31,18.51 48.84,10.89 48.84,10.89 L46.11,15.18 Z",
    id: "Path",
    fill: "#1C65AB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.43,74.13 C57.03,67.32 54.8399987,58.05 54.8399987,58.05 C54.8399987,58.05 54.81,73.95 63.78,86.7 C63.45,83.73 62.49,75.81 62.43,74.13 Z",
    id: "Path",
    fill: "#0F325F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.500000, 46.500000)",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33,47.55 C7.98,49.56 6.69,51.63 5.43,53.76 C3.66,52.08 1.92,50.34 0.21,48.57 C-0.39,34.11 1.62,19.71 4.68,5.82 C6.12,6.06 6.81,6.33 8.22,6.57 C6.84,20.34 7.2,34.14 9.33,47.55 Z",
    fill: "#070532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,6.57 C6.81,6.33 6.12,6.06 4.71,5.82 C4.41,3.69 4.47,1.38 5.34,0.24 C7.77,0.78 8.07,0.39 10.5,0.9 C9.72,2.79 8.97,4.65 8.25,6.57 Z",
    fill: "#070532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,6.57 C6.81,6.33 6.12,6.06 4.71,5.82 C4.41,3.69 4.59,0.36 5.73,0.24 C6.45,1.92 4.83,3.45 5.61,5.1 C6.54,5.85 7.29,5.82 8.25,6.57 Z",
    fill: "#060323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,6.57 C6.81,6.33 6.12,6.06 4.71,5.82 C1.65,19.71 -0.36,34.11 0.24,48.57 C0.3,34.62 2.1,20.94 5.52,7.86 C6.39,7.41 7.32,6.99 8.25,6.57 Z",
    fill: "#060323"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "41.91 48.09 37.47 52.11 35.55 46.92 44.97 42.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.88,45.9 L32.01,48.96 L35.55,46.92 C35.55,46.92 34.77,44.7 34.74,43.17 C34.35,43.35 32.88,45.9 32.88,45.9 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.63,69.78 C42.63,70.32 42.21,70.74 41.67,70.74 C41.13,70.74 40.71,70.32 40.71,69.78 C40.71,69.24 41.13,68.82 41.67,68.82 C42.21,68.82 42.63,69.27 42.63,69.78 Z",
    id: "Path",
    fill: "#FFFF70",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.56,85.59 C43.56,86.13 43.14,86.55 42.6,86.55 C42.06,86.55 41.64,86.13 41.64,85.59 C41.64,85.05 42.06,84.63 42.6,84.63 C43.14,84.66 43.56,85.08 43.56,85.59 Z",
    id: "Path",
    fill: "#FFFF70",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.56,100.26 C43.56,100.8 43.14,101.22 42.6,101.22 C42.06,101.22 41.64,100.8 41.64,100.26 C41.64,99.72 42.06,99.3 42.6,99.3 C43.14,99.3 43.56,99.75 43.56,100.26 Z",
    id: "Path",
    fill: "#FFFF70",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.52,111.69 C44.52,112.23 44.1,112.65 43.56,112.65 C43.02,112.65 42.6,112.23 42.6,111.69 C42.6,111.15 43.02,110.73 43.56,110.73 C44.1,110.73 44.52,111.15 44.52,111.69 Z",
    id: "Path",
    fill: "#FFFF70",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0F325F",
    fillRule: "nonzero",
    transform: "translate(57.633292, 100.622885) rotate(-9.131692) translate(-57.633292, -100.622885) ",
    x: 50.3884846,
    y: 98.4629418,
    width: 14.4896159,
    height: 4.31988548
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 0.000000)",
    fill: "#1C65AB",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "3.75 0.27 9.72 10.11 0.27 3.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.03 2.07 11.46 8.85 8.55 0.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.27 9.18 6.66 12.27 1.05 12.06"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0.12,131.43 C0.12,132.78 1.23,133.89 2.58,133.89 L37.32,133.89 C38.67,133.89 39.78,132.78 39.78,131.43 L39.78,78.66 C39.78,77.31 38.67,76.2 37.32,76.2 L2.58,76.2 C1.23,76.2 0.12,77.31 0.12,78.66 L0.12,131.43 L0.12,131.43 Z",
    id: "Path",
    fill: "#9E725F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFE8",
    fillRule: "nonzero",
    x: 3.15,
    y: 80.46,
    width: 33.93,
    height: 49.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.83,82.2 C31.83,78.3 26.52,75.15 19.95,75.15 C13.38,75.15 8.07,78.3 8.07,82.2 L31.83,82.2 Z",
    id: "Path",
    fill: "#B3B3B3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.53,77.91 C13.53,78.33 13.86,78.66 14.28,78.66 L25.56,78.66 C25.98,78.66 26.31,78.33 26.31,77.91 L26.31,72.84 C26.31,72.42 25.98,72.09 25.56,72.09 L14.28,72.09 C13.86,72.09 13.53,72.42 13.53,72.84 L13.53,77.91 Z",
    id: "Path",
    fill: "#B3B3B3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.18,79.44 C24.18,80.04 24.66,80.52 25.26,80.52 C25.86,80.52 26.34,80.04 26.34,79.44 C26.34,78.84 25.86,78.36 25.26,78.36 C24.66,78.39 24.18,78.87 24.18,79.44 Z",
    id: "Path",
    fill: "#878787",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.08,79.44 C13.08,80.04 13.56,80.52 14.16,80.52 C14.76,80.52 15.24,80.04 15.24,79.44 C15.24,78.84 14.76,78.36 14.16,78.36 C13.56,78.39 13.08,78.87 13.08,79.44 Z",
    id: "Path",
    fill: "#878787",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.59,70.29 C16.59,72.15 18.09,73.65 19.95,73.65 C21.81,73.65 23.31,72.15 23.31,70.29 C23.31,68.43 21.81,66.93 19.95,66.93 C18.09,66.96 16.59,68.46 16.59,70.29 Z M18.39,70.29 C18.39,69.42 19.08,68.73 19.95,68.73 C20.82,68.73 21.51,69.42 21.51,70.29 C21.51,71.16 20.82,71.85 19.95,71.85 C19.08,71.85 18.39,71.16 18.39,70.29 Z",
    id: "Shape",
    fill: "#B3B3B3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCA7",
    fillRule: "nonzero",
    x: 7.11,
    y: 88.17,
    width: 25.56,
    height: 4.08
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCA7",
    fillRule: "nonzero",
    x: 7.11,
    y: 94.29,
    width: 25.56,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCA7",
    fillRule: "nonzero",
    x: 21.06,
    y: 97.74,
    width: 11.64,
    height: 2.04
  }), /*#__PURE__*/React.createElement("text", {
    id: "?",
    fill: "#F56262",
    fontFamily: "Helvetica",
    fontSize: 23.4270956,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.73709,
    y: 123.36123
  }, "?")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSupport);
export default __webpack_public_path__ + "static/media/contactSupport.a1e8432cc5a523a61445a28ab5c339a9.svg";
export { ForwardRef as ReactComponent };